// TODO: j-селектор! код дублирует components/contacts/index.js!
const footerMenuTitles = [...document.querySelectorAll('.footer__nav-title')];
const footerMenuListTitle = document.querySelector('.footer__nav-list-title');
const activeClass = 'is-active';

footerMenuTitles.forEach((item) => {
    item.addEventListener('click', () => {
        item.classList.toggle(activeClass);
        item.nextElementSibling.classList.toggle(activeClass);
    });
});

footerMenuListTitle && footerMenuListTitle.addEventListener('click', () => {
    footerMenuListTitle.classList.toggle(activeClass);
    footerMenuListTitle.nextElementSibling.classList.toggle(activeClass);
});
